export const COMPANY_PHONE_RAW = "18704556742"
export const COMPANY_PHONE_FORMATTED = "1-870-455-6742"
export const COMPANY_PHONE_TEL = "tel:+18704556742"
